// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610090635/js/" + chunkId + "." + {"44":"b4100335","225":"224e8ff5","481":"8628e803","486":"206ff234","770":"4270fc02"}[chunkId] + ".0.4523907523334181.chunk.js";
};